import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const rootEl = document.getElementById("root");

if (!rootEl) {
  document.body.innerHTML = `<div style="font-family:sans-serif;padding:40px;text-align:center;color:#ef4444">
    <h1>Erro Crítico</h1><p>Elemento #root não encontrado. Verifique o index.html.</p>
  </div>`;
} else {
  try {
    createRoot(rootEl).render(<App />);
  } catch (e) {
    console.error("[DataGrid XML] Falha fatal ao montar a aplicação:", e);
    rootEl.innerHTML = `<div style="font-family:sans-serif;padding:40px;text-align:center;color:#ef4444">
      <h1>Erro ao Inicializar</h1>
      <p>Ocorreu um erro fatal. Verifique o console para detalhes.</p>
      <pre style="text-align:left;background:#1e1e1e;color:#fff;padding:16px;border-radius:8px;margin-top:16px;overflow:auto">${e}</pre>
    </div>`;
  }
}
